import { getDate } from '../../../api/Select'

/**
 * 订单流程数据 mixin：封装 V_ORD_TASKDTL、V_ORD_PROCESS、ORD_PROCESS
 * 的查询、保存、合并、附件汇总和状态归一化逻辑。
 */
export default {
  methods: {
    /**
     * 统一订单任务行字段大小写和关键主键兜底。
     */
    normalizeOrderTaskRow: function (row) {
      var source = Object.assign({}, row || {})
      var keys = [
        'IDSEQ', 'LSTSEQ', 'CODE', 'PARENTNO', 'WKNM', 'EMPNM', 'EMPNM2', 'EMPIDSEQ',
        'FRDTTM', 'FINDTTM', 'ITEMTY', 'WKTY', 'STFG', 'REFIDSEQ', 'REFLSTSEQ',
        'REFIDNO', 'REFIDTY', 'REFIDTYNM', 'TASK_IDSEQ', 'TASK_LSTSEQ', 'RMK',
        'ADDUSER', 'ADDDTTM', 'UPDUSER', 'UPDDTTM', 'CORPID', 'ORDNO', 'MATNO',
        'MATNM', 'MATDESC', 'CLNTNM', 'PCT'
      ]
      keys.forEach(function (key) {
        if (source[key] === undefined && source[key.toLowerCase()] !== undefined) source[key] = source[key.toLowerCase()]
      })
      if (!source.LSTSEQ && source.IDSEQ) source.LSTSEQ = source.IDSEQ
      if (!source.LSTSEQ && source.CODE) source.LSTSEQ = source.CODE
      if (!source.CODE && source.LSTSEQ) source.CODE = source.LSTSEQ
      if (!source.TASK_IDSEQ) source.TASK_IDSEQ = source.IDSEQ || source.LSTSEQ || source.CODE || ''
      if (!source.TASK_LSTSEQ) source.TASK_LSTSEQ = source.LSTSEQ || source.IDSEQ || source.CODE || ''
      if (!source.EMPNM && source.EMPNM2) source.EMPNM = source.EMPNM2
      if (!source.EMPNM2 && source.EMPNM) source.EMPNM2 = source.EMPNM
      return source
    },
    /**
     * 批量规范订单任务行。
     */
    normalizeOrderTaskRows: function (rows) {
      return this.normalizeRows(rows).map(function (row) {
        return this.normalizeOrderTaskRow(row)
      }.bind(this))
    },
    /**
     * 生成订单任务去重 key，优先使用模板任务身份。
     */
    getOrderTaskDedupeKey: function (row, index) {
      row = row || {}
      var taskIdseq = String(row.TASK_IDSEQ || '').trim()
      var taskLstseq = String(row.TASK_LSTSEQ || '').trim()
      if (taskIdseq || taskLstseq) return 'task:' + taskIdseq + '-' + taskLstseq
      var rowKey = String(row.CODE || row.LSTSEQ || row.IDSEQ || '').trim()
      return rowKey ? ('row:' + rowKey) : ('index:' + index)
    },
    /**
     * 取得任务行用于优先级比较的时间。
     */
    getOrderTaskSortTime: function (row) {
      row = row || {}
      return String(row.ADDDTTM || row.UPDDTTM || '').trim()
    },
    /**
     * 取得任务排序值，数字编码按数值排序，其它按字符串排序。
     */
    getOrderTaskSortValue: function (row, fallback) {
      row = row || {}
      var value = row.TASK_LSTSEQ || row.CODE || row.LSTSEQ || row.IDSEQ || fallback || ''
      var numberValue = Number(value)
      return isNaN(numberValue) ? String(value) : numberValue
    },
    /**
     * 判断同一任务分组中哪个任务行更适合保留。
     */
    isPreferredOrderTaskRow: function (nextRow, currentRow, parentRefMap) {
      if (!currentRow) return true
      var nextCode = String((nextRow && (nextRow.CODE || nextRow.LSTSEQ || nextRow.IDSEQ)) || '').trim()
      var currentCode = String((currentRow && (currentRow.CODE || currentRow.LSTSEQ || currentRow.IDSEQ)) || '').trim()
      var nextReferenced = !!parentRefMap[nextCode]
      var currentReferenced = !!parentRefMap[currentCode]
      if (nextReferenced !== currentReferenced) return nextReferenced
      var nextTime = this.getOrderTaskSortTime(nextRow)
      var currentTime = this.getOrderTaskSortTime(currentRow)
      if (nextTime && currentTime && nextTime !== currentTime) return nextTime < currentTime
      if (nextTime !== currentTime) return !!nextTime
      var nextId = Number((nextRow && (nextRow.IDSEQ || nextRow.LSTSEQ || nextRow.CODE)) || 0)
      var currentId = Number((currentRow && (currentRow.IDSEQ || currentRow.LSTSEQ || currentRow.CODE)) || 0)
      if (!isNaN(nextId) && !isNaN(currentId) && nextId !== currentId) return nextId < currentId
      return false
    },
    /**
     * 去除重复订单任务行，保留被父节点引用或时间更早的有效行。
     */
    dedupeOrderTaskRows: function (rows) {
      var sourceRows = this.normalizeRows(rows)
      var parentRefMap = {}
      sourceRows.forEach(function (row) {
        var parentNo = String((row && row.PARENTNO) || '').trim()
        if (parentNo && parentNo !== '#') parentRefMap[parentNo] = true
      })
      var groupMap = {}
      sourceRows.forEach(function (row, index) {
        var key = this.getOrderTaskDedupeKey(row, index)
        if (!groupMap[key]) {
          groupMap[key] = {
            selected: row,
            rows: [row]
          }
          return
        }
        groupMap[key].rows.push(row)
        if (this.isPreferredOrderTaskRow(row, groupMap[key].selected, parentRefMap)) groupMap[key].selected = row
      }.bind(this))
      var seenMap = {}
      var dedupedRows = []
      sourceRows.forEach(function (row, index) {
        var key = this.getOrderTaskDedupeKey(row, index)
        if (seenMap[key] || !groupMap[key] || groupMap[key].selected !== row) return
        seenMap[key] = true
        dedupedRows.push(row)
      }.bind(this))
      return dedupedRows.sort(function (left, right) {
        var leftValue = this.getOrderTaskSortValue(left, 0)
        var rightValue = this.getOrderTaskSortValue(right, 0)
        if (leftValue === rightValue) return 0
        if (typeof leftValue === 'number' && typeof rightValue === 'number') return leftValue - rightValue
        return String(leftValue).localeCompare(String(rightValue))
      }.bind(this))
    },
    /**
     * 过滤没有编码或名称、不能用于渲染的任务行。
     */
    filterUsableOrderTaskRows: function (rows) {
      return this.normalizeRows(rows).filter(function (row) {
        var code = String((row && row.CODE) || '').trim()
        var wknm = String((row && row.WKNM) || '').trim()
        return !!code && !!wknm
      })
    },
    /**
     * 获取当前订单号，兼容不同来源字段。
     */
    getOrderNo: function () {
      var row = this.effectiveOrderRow || this.currentProjectRow || {}
      return row.REFIDNO || row.refidno || row.ORDNO || row.ordno || row.IDNO || row.idno || ''
    },
    /**
     * 获取查询订单任务骨架所需的订单主键。
     */
    getOrderTaskQueryIdentity: function () {
      var row = this.effectiveOrderRow && Object.keys(this.effectiveOrderRow).length
        ? this.effectiveOrderRow
        : (this.currentProjectRow || {})
      return {
        refIdseq: row.IDSEQ || row.REFIDSEQ || row.ORD_IDSEQ || '',
        refLstseq: row.LSTSEQ || row.REFLSTSEQ || row.ORD_LSTSEQ || ''
      }
    },
    /**
     * 从新增任务接口返回中提取任务 IDSEQ。
     */
    getOrderTaskRowId: function (responseData, fallback) {
      var data = responseData || {}
      return data.idseq || data.IDSEQ || data.lstseq || data.LSTSEQ || fallback || ''
    },
    /**
     * 从 V_ORD_TASKDTL 加载当前订单的流程骨架。
     */
    loadOrderTaskRows: function () {
      var taskIdentity = this.getOrderTaskQueryIdentity()
      if (!taskIdentity.refIdseq || !taskIdentity.refLstseq) {
        return Promise.resolve([])
      }
      var payload = {
        p_table: 'V_ORD_TASKDTL',
        p_key: 'REFIDSEQ',
        p_value: taskIdentity.refIdseq,
        p_key2: 'REFLSTSEQ',
        p_value2: taskIdentity.refLstseq,
        p_cond: ''
      }
      return this.loadTableRows(
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (rows) {
        var normalizedRows = this.filterUsableOrderTaskRows(this.dedupeOrderTaskRows(this.normalizeOrderTaskRows(rows)))
        return normalizedRows
      }.bind(this))
    },
    /**
     * 构造新增 ORD_TASKDTL 节点的保存载荷。
     */
    buildOrderTaskPayload: function (row, parentNo, taskIdseq, taskLstseq) {
      row = row || {}
      var identity = this.getOrderIdentity()
      var now = getDate('full')
      var owner = row.EMPNM || row.EMPNM2 || ''
      return {
        CODE: row.CODE || '',
        PARENTNO: parentNo || '#',
        WKNM: row.WKNM || '',
        EMPNM: owner,
        EMPIDSEQ: this.normalizeNumberValue(row.EMPIDSEQ || ''),
        FRDTTM: '',
        FINDTTM: '',
        ITEMTY: row.ITEMTY || '',
        WKTY: row.WKTY || '',
        STFG: '',
        REFIDSEQ: this.normalizeNumberValue(identity.ordIdseq),
        REFLSTSEQ: this.normalizeNumberValue(identity.ordLstseq),
        REFIDNO: this.getOrderNo(),
        REFIDTY: row.REFIDTY || '',
        REFIDTYNM: row.REFIDTYNM || '',
        TASK_IDSEQ: this.normalizeNumberValue(taskIdseq || row.TASK_IDSEQ || row.IDSEQ || ''),
        TASK_LSTSEQ: this.normalizeNumberValue(taskLstseq || row.TASK_LSTSEQ || row.LSTSEQ || ''),
        RMK: row.RMK || '',
        ADDUSER: this.vUsernm,
        ADDDTTM: now,
        UPDUSER: this.vUsernm,
        UPDDTTM: now
      }
    },
    /**
     * 保存新增订单任务节点到 ORD_TASKDTL。
     */
    saveOrderTaskRow: function (payload) {
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/formOneSave'),
        data: { p_json: JSON.stringify(payload), p_table: 'ORD_TASKDTL', p_idseq: '' }
      }).then(function (res) {
        if (!this.isOkSaveResponse(res)) throw new Error(this.getSaveResponseError(res))
        return Object.assign({}, payload, { IDSEQ: this.getOrderTaskRowId(res, payload.IDSEQ) })
      }.bind(this))
    },
    /**
     * 更新订单任务节点的指定字段。
     */
    updateOrderTaskRow: function (idseq, pairs) {
      if (!idseq) return Promise.resolve()
      var cond = this.buildUpdateCond(pairs || [])
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/updateRec'),
        data: { p_key: 'idseq', p_value: idseq, p_table: 'ORD_TASKDTL', p_cond: cond }
      }).then(function (res) {
        if (!this.isOkSaveResponse(res)) throw new Error(this.getSaveResponseError(res))
        return res
      }.bind(this))
    },
    /**
     * 删除指定表记录，支持单主键或双主键删除。
     */
    deleteRecord: function (table, key, value, key2, value2) {
      var payload = {
        p_key: key,
        p_value: value,
        p_table: table
      }
      if (key2) {
        payload.p_key2 = key2
        payload.p_value2 = value2
      }
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/delTabRec'),
        data: payload
      }).then(function (res) {
        if (!this.isOkSaveResponse(res)) throw new Error(this.getSaveResponseError(res))
        return res
      }.bind(this))
    },
    /**
     * 根据订单号和物料号生成订单标题。
     */
    buildOrderTitle: function (row) {
      row = row || {}
      var ordno = row.REFIDNO || row.refidno || row.ORDNO || row.ordno || row.IDNO || row.idno || ''
      var matno = row.MATNO || row.matno || row.PRDNO || row.prdno || ''
      return [ordno, matno].filter(function (item) { return item }).join(' ') || this.$LANG('', '生产订单')
    },
    /**
     * 获取订单维护记录使用的订单身份。
     */
    getOrderIdentity: function () {
      var row = this.effectiveOrderRow || this.currentProjectRow || {}
      return {
        ordIdseq: row.ORD_IDSEQ || row.IDSEQ || '',
        ordLstseq: row.ORD_LSTSEQ || row.LSTSEQ || '',
        corpid: row.CORPID || this.vCorpid || ''
      }
    },
    /**
     * 获取订单任务模板身份。
     */
    getOrderTaskIdentity: function (row) {
      row = row || {}
      return {
        taskIdseq: row.TASK_IDSEQ || row.TEMPLATE_IDSEQ || row.IDSEQ || '',
        taskLstseq: row.TASK_LSTSEQ || row.TEMPLATE_LSTSEQ || row.LSTSEQ || ''
      }
    },
    /**
     * 获取 ORD_PROCESS 维护记录对应的任务身份。
     */
    getOrderProcessTaskIdentity: function (row) {
      row = row || {}
      return {
        taskIdseq: row.TASK_IDSEQ || row.TEMPLATE_IDSEQ || row.IDSEQ || row.idseq || '',
        taskLstseq: row.TASK_LSTSEQ || row.TEMPLATE_LSTSEQ || row.CODE || row.code || row.LSTSEQ || row.lstseq || ''
      }
    },
    /**
     * 从候选值列表中取第一个非空值。
     */
    getFirstFilledValue: function (values, defaultValue) {
      for (var i = 0; i < values.length; i++) {
        if (values[i] !== undefined && values[i] !== null && values[i] !== '') return values[i]
      }
      return defaultValue
    },
    /**
     * 将可转数字的值转成数字，否则保留原值。
     */
    normalizeNumberValue: function (value) {
      if (value === undefined || value === null || value === '') return ''
      var numberValue = Number(value)
      return isNaN(numberValue) ? value : numberValue
    },
    /**
     * 生成订单维护记录缓存 key。
     */
    getOrderProcessKey: function (idseq, lstseq) {
      return String(idseq || '') + '-' + String(lstseq || '')
    },
    /**
     * 取得维护记录排序时间，优先使用更新时间。
     */
    getOrderProcessSortTime: function (row) {
      row = row || {}
      return String(row.UPDDTTM || row.ADDDTTM || row.FINDTTM || '')
    },
    /**
     * 获取订单维护记录负责人。
     */
    getOrderProcessOwner: function (row) {
      row = row || {}
      return String(row.EMPNM || '').trim()
    },
    /**
     * 获取订单维护记录截止日期。
     */
    getOrderProcessFindDate: function (row) {
      row = row || {}
      return String(row.ORDER_PROCESS_FINDTTM || row.FINDTTM || '').trim()
    },
    /**
     * 判断当前用户是否为订单根节点负责人。
     */
    isCurrentOrderOwner: function () {
      var rootRow = this.effectiveOrderRow && Object.keys(this.effectiveOrderRow).length
        ? this.effectiveOrderRow
        : (this.currentProjectRow || {})
      var orderOwner = String(this.pickOrderOwner(rootRow) || '').trim()
      return !!orderOwner && orderOwner === this.vUsernm
    },
    /**
     * 判断当前用户是否可以维护该任务，管理员、订单负责人、任务负责人均可维护。
     */
    canMaintainOrderProcessRow: function (row) {
      if (this.vAdmin === 'Y') return true
      if (this.isCurrentOrderOwner()) return true
      var owner = this.getOrderProcessOwner(row)
      return !owner || owner === this.vUsernm
    },
    /**
     * 判断 nextRow 是否比 currentRow 更新。
     */
    isNewerOrderProcessRow: function (nextRow, currentRow) {
      if (!currentRow) return true
      var nextTime = this.getOrderProcessSortTime(nextRow)
      var currentTime = this.getOrderProcessSortTime(currentRow)
      if (nextTime !== currentTime) return nextTime > currentTime
      return Number(nextRow && nextRow.IDSEQ) > Number(currentRow && currentRow.IDSEQ)
    },
    /**
     * 生成某个任务行对应的维护记录缓存 key。
     */
    getOrderProcessRowKey: function (row) {
      var identity = this.getOrderProcessTaskIdentity(row)
      return this.getOrderProcessKey(identity.taskIdseq, identity.taskLstseq)
    },
    /**
     * 从已加载的维护记录缓存中查找任务对应记录。
     */
    getOrderProcessRowFromCache: function (row) {
      var key = this.getOrderProcessRowKey(row)
      var rows = this.orderProcessRows || []
      for (var i = 0; i < rows.length; i++) {
        if (this.getOrderProcessKey(rows[i].TASK_IDSEQ, rows[i].TASK_LSTSEQ) === key) return rows[i]
      }
      return null
    },
    /**
     * 获取任务对应的 ORD_PROCESS 主键。
     */
    getOrderProcessId: function (row) {
      row = row || {}
      var cached = this.getOrderProcessRowFromCache(row) || {}
      return row.ORDER_PROCESS_IDSEQ || cached.IDSEQ || ''
    },
    /**
     * 构造新增或更新 ORD_PROCESS 的保存载荷。
     */
    buildOrderProcessPayload: function (row, overrides) {
      row = row || {}
      overrides = Object.assign({}, overrides || {})
      var forceInsert = !!overrides.FORCE_INSERT
      delete overrides.FORCE_INSERT
      delete overrides.REFIDSEQ
      delete overrides.REFLSTSEQ
      delete overrides.REFIDNO
      var identity = this.getOrderIdentity()
      var taskIdentity = this.getOrderProcessTaskIdentity(row)
      var now = getDate('full')
      var idseq = forceInsert ? '' : (overrides.IDSEQ !== undefined ? overrides.IDSEQ : this.getOrderProcessId(row))
      var hasOrderProcess = !forceInsert && ((idseq !== undefined && idseq !== null && idseq !== '') || row.ORDER_PROCESS_EXISTS)
      var addUser = hasOrderProcess ? (row.ADDUSER || this.vUsernm) : this.vUsernm
      var addDttm = hasOrderProcess ? (row.ADDDTTM || now) : now
      return Object.assign({}, overrides, {
        IDSEQ: this.normalizeNumberValue(idseq),
        ORD_IDSEQ: this.normalizeNumberValue(identity.ordIdseq),
        ORD_LSTSEQ: this.normalizeNumberValue(identity.ordLstseq),
        TASK_IDSEQ: this.normalizeNumberValue(taskIdentity.taskIdseq),
        TASK_LSTSEQ: this.normalizeNumberValue(taskIdentity.taskLstseq),
        EMPNM: overrides.EMPNM !== undefined ? overrides.EMPNM : this.getOrderProcessOwner(row),
        FINDTTM: overrides.FINDTTM !== undefined ? overrides.FINDTTM : this.getOrderProcessFindDate(row),
        STFG: overrides.STFG !== undefined ? overrides.STFG : (row.STFG || '未开始'),
        PCT: Number(overrides.PCT !== undefined ? overrides.PCT : (row.PCT || 0)),
        RMK: overrides.RMK !== undefined ? overrides.RMK : (row.RMK || ''),
        CORPID: identity.corpid,
        ADDUSER: addUser || this.vUsernm,
        ADDDTTM: addDttm || now,
        UPDUSER: this.vUsernm,
        UPDDTTM: now
      })
    },
    /**
     * 将保存后的 ORD_PROCESS 行合并回任务节点行。
     */
    normalizeOrderProcessSavedRow: function (baseRow, savedRow) {
      var merged = this.mergeOrderProcessStatus(baseRow, savedRow)
      return Object.assign({}, merged, {
        IDSEQ: baseRow.IDSEQ,
        LSTSEQ: baseRow.LSTSEQ,
        ORDER_PROCESS_IDSEQ: savedRow.IDSEQ || merged.ORDER_PROCESS_IDSEQ,
        ORDER_PROCESS_EXISTS: true
      })
    },
    /**
     * 新增或替换本地 ORD_PROCESS 缓存。
     */
    upsertOrderProcessCache: function (row) {
      if (!row || !row.TASK_IDSEQ || !row.TASK_LSTSEQ) return
      var key = this.getOrderProcessKey(row.TASK_IDSEQ, row.TASK_LSTSEQ)
      var updated = false
      this.orderProcessRows = (this.orderProcessRows || []).map(function (item) {
        if (this.getOrderProcessKey(item.TASK_IDSEQ, item.TASK_LSTSEQ) === key) {
          updated = true
          return Object.assign({}, item, row)
        }
        return item
      }.bind(this))
      if (!updated) this.orderProcessRows.push(row)
    },
    /**
     * 保存任务维护信息，已有记录走 updateRec，新增记录走 formOneSave。
     */
    saveOrderProcessRow: function (row, overrides) {
      var payload = this.buildOrderProcessPayload(row, overrides)
      var isUpdate = !!payload.IDSEQ
      if (isUpdate) {
        var cond = this.buildUpdateCond([
          { key: 'ord_idseq', value: payload.ORD_IDSEQ },
          { key: 'ord_lstseq', value: payload.ORD_LSTSEQ },
          { key: 'task_idseq', value: payload.TASK_IDSEQ },
          { key: 'task_lstseq', value: payload.TASK_LSTSEQ },
          { key: 'corpid', value: payload.CORPID },
          { key: 'empnm', value: payload.EMPNM },
          { key: 'findttm', value: payload.FINDTTM },
          { key: 'stfg', value: payload.STFG },
          { key: 'pct', value: Number(payload.PCT) || 0 },
          { key: 'rmk', value: payload.RMK || '' },
          { key: 'upduser', value: payload.UPDUSER },
          { key: 'upddttm', value: payload.UPDDTTM }
        ])
        return this.$axios({
          method: 'post',
          url: this.authUrl('xuper_auth/updateRec'),
          data: { p_key: 'idseq', p_value: payload.IDSEQ, p_table: 'ORD_PROCESS', p_cond: cond }
        }).then(function (res) {
          if (res && res.code && res.code !== '200') throw new Error(res.result || res.message || this.$LANG('1442', '提示'))
          this.upsertOrderProcessCache(payload)
          return payload
        }.bind(this))
      }
      return this.$axios({
        method: 'post',
        url: this.authUrl('xuper_auth/formOneSave'),
        data: { p_json: JSON.stringify(payload), p_table: 'ORD_PROCESS', p_idseq: '' }
      }).then(function (res) {
        if (res && res.code !== '200') throw new Error(res.result || res.message || this.$LANG('1442', '提示'))
        var saved = Object.assign({}, payload, { IDSEQ: res.idseq || payload.IDSEQ })
        this.upsertOrderProcessCache(saved)
        return saved
      }.bind(this))
    },
    /**
     * 从 V_ORD_PROCESS 加载当前订单所有任务维护记录。
     */
    loadOrderProcessRows: function () {
      var identity = this.getOrderIdentity()
      if (!identity.ordIdseq || !identity.ordLstseq) return Promise.resolve([])
      var payload = {
        p_table: 'V_ORD_PROCESS',
        p_key: 'ORD_IDSEQ',
        p_value: identity.ordIdseq,
        p_key2: 'ORD_LSTSEQ',
        p_value2: identity.ordLstseq,
        p_key3: identity.corpid ? 'CORPID' : '',
        p_value3: identity.corpid || '',
        p_cond: ' order by TASK_LSTSEQ'
      }
      return this.loadTableRows(
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (rows) {
        return rows
      })
    },
    /**
     * 转义 SQL 条件中的单引号。
     */
    escapeSqlValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    /**
     * 判断日志备注是否为有效内容。
     */
    hasLogRemark: function (value) {
      var text = String(value === undefined || value === null ? '' : value).trim()
      return !!text && text !== '-'
    },
    /**
     * 加载指定任务的 ORD_PROCESS 明细记录。
     */
    loadOrderProcessDetailRows: function (row) {
      var identity = this.getOrderIdentity()
      var taskIdentity = this.getOrderProcessTaskIdentity(row)
      if (!identity.ordIdseq || !identity.ordLstseq || !taskIdentity.taskIdseq || !taskIdentity.taskLstseq) return Promise.resolve([])
      var cond = " and TASK_LSTSEQ='" + this.escapeSqlValue(taskIdentity.taskLstseq) + "'"
      if (identity.corpid) cond += " and CORPID='" + this.escapeSqlValue(identity.corpid) + "'"
      cond += ' order by UPDDTTM desc, ADDDTTM desc'
      var payload = {
        p_table: 'V_ORD_PROCESS',
        p_key: 'ORD_IDSEQ',
        p_value: identity.ordIdseq,
        p_key2: 'ORD_LSTSEQ',
        p_value2: identity.ordLstseq,
        p_key3: 'TASK_IDSEQ',
        p_value3: taskIdentity.taskIdseq,
        p_cond: cond
      }
      return this.loadTableRows(
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (rows) {
        return rows
      })
    },
    /**
     * 直接从 ORD_PROCESS 表加载指定任务记录，用于删除节点前清理。
     */
    loadOrderProcessTableRowsForTask: function (row) {
      var identity = this.getOrderIdentity()
      var taskIdentity = this.getOrderProcessTaskIdentity(row)
      if (!identity.ordIdseq || !identity.ordLstseq || !taskIdentity.taskIdseq || !taskIdentity.taskLstseq) return Promise.resolve([])
      var cond = " and TASK_LSTSEQ='" + this.escapeSqlValue(taskIdentity.taskLstseq) + "'"
      if (identity.corpid) cond += " and CORPID='" + this.escapeSqlValue(identity.corpid) + "'"
      cond += ' order by IDSEQ'
      return this.loadTableRows('ORD_PROCESS', 'ORD_IDSEQ', identity.ordIdseq, 'ORD_LSTSEQ', identity.ordLstseq, 'TASK_IDSEQ', taskIdentity.taskIdseq, cond)
    },
    /**
     * 将维护记录转换为详情侧栏日志格式。
     */
    formatOrderProcessLogList: function (rows) {
      return this.normalizeRows(rows).map(function (item) {
        var displayStatus = this.normalizeOrderStatus(item.STFG, Number(item.PCT) || 0)
        var statusInfo = this.getStatusInfo(displayStatus)
        return Object.assign({}, item, {
          DTTM: item.UPDDTTM || item.ADDDTTM || '',
          LOGRMK: item.RMK || '',
          ADDUSER: item.ADDUSER || item.UPDUSER || '',
          COLOR: statusInfo.color,
          PHODATA: []
        })
      }.bind(this))
    },
    /**
     * 获取附件 owner ID，当前使用任务节点 ID 归档附件。
     */
    getOrderProcessAttachmentOwnerId: function (row) {
      row = row || this.currentTaskRow || {}
      return row.IDSEQ || row.CODE || row.LSTSEQ || ''
    },
    /**
     * 获取跟进记录附件关联的日志 ID。
     */
    getOrderProcessAttachmentLogId: function (row) {
      row = row || {}
      return row.ORDER_PROCESS_IDSEQ || row.IDSEQ || ''
    },
    /**
     * 加载某条跟进日志的附件。
     */
    loadOrderProcessLogAttachments: function (taskRow, logRow) {
      var ownerId = this.getOrderProcessAttachmentOwnerId(taskRow)
      var logId = this.getOrderProcessAttachmentLogId(logRow)
      if (!ownerId || !logId) return Promise.resolve([])
      return this.loadTableRows('V_MAT_IMG', 'idseq', ownerId, 'filety', 'IMG', 'REFLSTSEQ', logId, ' order by lstseq')
    },
    /**
     * 给每条跟进日志挂载附件列表。
     */
    attachOrderProcessLogAttachments: function (taskRow, rows) {
      var detailRows = this.formatOrderProcessLogList(rows)
      return Promise.all(detailRows.map(function (item) {
        return this.loadOrderProcessLogAttachments(taskRow, item).then(function (attachments) {
          return Object.assign({}, item, { PHODATA: attachments })
        })
      }.bind(this)))
    },
    /**
     * 汇总当前节点所有日志附件并去重。
     */
    mergeLogAttachmentsForNode: function (detailRows) {
      var seen = {}
      var result = []
      this.normalizeRows(detailRows).forEach(function (row) {
        this.normalizeRows(row && row.PHODATA).forEach(function (item) {
          var key = [
            item.IDSEQ || '',
            item.LSTSEQ || '',
            item.FILEPATH || item.PATH || item.FILENM || ''
          ].join('|')
          if (seen[key]) return
          seen[key] = true
          result.push(item)
        })
      }.bind(this))
      return result
    },
    /**
     * 合并多组附件列表并按附件身份去重。
     */
    mergeAttachments: function (lists) {
      var seen = {}
      var result = []
      this.normalizeRows(lists).forEach(function (list) {
        this.normalizeRows(list).forEach(function (item) {
          var key = [
            item.IDSEQ || '',
            item.LSTSEQ || '',
            item.FILEPATH || item.PATH || item.FILENM || ''
          ].join('|')
          if (seen[key]) return
          seen[key] = true
          result.push(item)
        })
      }.bind(this))
      return result
    },
    /**
     * 汇总整张订单流程图的根节点附件。
     */
    loadOrderRootAttachments: function () {
      var taskRows = this.normalizeRows(this.internalWorkDetails).filter(function (taskRow) {
        if (!taskRow || taskRow.id === 'root') return false
        var taskIdentity = this.getOrderProcessTaskIdentity(taskRow)
        return !!(taskIdentity.taskIdseq && taskIdentity.taskLstseq)
      }.bind(this))
      if (!taskRows.length) return Promise.resolve([])
      return Promise.all(taskRows.map(function (taskRow) {
        return this.loadOrderProcessDetailRows(taskRow).then(function (detailRows) {
          if (!detailRows || !detailRows.length) return []
          return this.attachOrderProcessLogAttachments(taskRow, detailRows).then(function (rowsWithAttachments) {
            return this.mergeLogAttachmentsForNode(rowsWithAttachments)
          }.bind(this))
        }.bind(this))
      }.bind(this))).then(function (result) {
        return this.mergeAttachments(result).sort(function (a, b) {
          return String(b.ADDDTTM || '').localeCompare(String(a.ADDDTTM || ''))
        })
      }.bind(this))
    },
    /**
     * 从多条维护记录中选择最新状态记录。
     */
    pickLatestOrderProcessRow: function (rows) {
      var latest = null
      this.normalizeRows(rows).forEach(function (item) {
        if (this.isNewerOrderProcessRow(item, latest)) latest = item
      }.bind(this))
      return latest
    },
    /**
     * 刷新当前任务详情：维护记录、日志列表和附件列表。
     */
    refreshOrderProcessDetailRows: function (row, requestToken, preferredStatusRow) {
      return this.loadOrderProcessDetailRows(row).then(function (rows) {
        if (requestToken && requestToken !== this.fishboneDetailRequestToken) return []
        var detailSourceRows = (rows || []).slice()
        if (preferredStatusRow) {
          var exists = detailSourceRows.some(function (item) {
            return String(item && item.IDSEQ) === String(preferredStatusRow.IDSEQ)
          })
          if (!exists) detailSourceRows.unshift(preferredStatusRow)
        }
        var statusRow = this.pickLatestOrderProcessRow(detailSourceRows)
        if (statusRow) {
          this.fishboneTaskRow = this.normalizeOrderProcessSavedRow(row, statusRow)
        } else {
          this.fishboneTaskRow = this.mergeOrderProcessStatus(row, null)
        }
        this.fishboneTaskRow = this.applyCachedSourceStatuses([this.fishboneTaskRow])[0] || this.fishboneTaskRow
        return this.attachOrderProcessLogAttachments(row, detailSourceRows)
      }.bind(this)).then(function (detailRows) {
        if (requestToken && requestToken !== this.fishboneDetailRequestToken) return []
        this.fishboneLogList = detailRows
        this.fishboneTaskAttachments = this.mergeLogAttachmentsForNode(detailRows)
        return detailRows
      }.bind(this))
    },
    /**
     * 将订单任务骨架和维护记录合并为最终节点状态。
     */
    mergeOrderProcessStatus: function (templateRow, statusRow) {
      var template = Object.assign({}, templateRow || {})
      var identity = this.getOrderIdentity()
      var templateIdentity = this.getOrderTaskIdentity(template)
      var processIdentity = this.getOrderProcessTaskIdentity(template)
      var orderRoot = this.effectiveOrderRow || this.currentProjectRow || {}
      var templateSourceStatus = '未开始'
      if (!statusRow) {
        return Object.assign({}, template, {
          ORDER_PROCESS_EXISTS: false,
          ORDER_PROCESS_IDSEQ: '',
          ORD_IDSEQ: identity.ordIdseq,
          ORD_LSTSEQ: identity.ordLstseq,
          TASK_IDSEQ: processIdentity.taskIdseq,
          TASK_LSTSEQ: processIdentity.taskLstseq,
          TEMPLATE_IDSEQ: templateIdentity.taskIdseq,
          TEMPLATE_LSTSEQ: templateIdentity.taskLstseq,
          ORDNO: template.ORDNO || orderRoot.ORDNO || orderRoot.IDNO || '',
          CLNTNM: template.CLNTNM || orderRoot.CLNTNM || '',
          MATNO: template.MATNO || orderRoot.MATNO || orderRoot.PRDNO || '',
          MATNM: template.MATNM || orderRoot.MATNM || '',
          MATDESC: template.MATDESC || orderRoot.MATDESC || '',
          CORPID: template.CORPID || orderRoot.CORPID || identity.corpid || '',
          NODE_FINDTTM: '',
          ORDER_PROCESS_FINDTTM: '',
          FINDTTM: '',
          EMPNM: template.EMPNM || template.EMPNM2 || '',
          EMPNM2: template.EMPNM2 || template.EMPNM || '',
          STFG: '未开始',
          DISPLAY_STFG: templateSourceStatus,
          SOURCE_STFG: '',
          PCT: 0
        })
      }
      var pct = this.getFirstFilledValue([statusRow.PCT], 0)
      var stfg = this.getFirstFilledValue([statusRow.STFG], '未开始')
      var owner = this.getOrderProcessOwner(statusRow) || template.EMPNM || template.EMPNM2 || ''
      var statusInfo = this.normalizeOrderStatus(stfg, Number(pct) || 0)
      return Object.assign({}, template, {
        ORDER_PROCESS_EXISTS: true,
        ORDER_PROCESS_IDSEQ: statusRow.IDSEQ || '',
        ORD_IDSEQ: statusRow.ORD_IDSEQ || identity.ordIdseq,
        ORD_LSTSEQ: statusRow.ORD_LSTSEQ || identity.ordLstseq,
        TASK_IDSEQ: statusRow.TASK_IDSEQ || processIdentity.taskIdseq,
        TASK_LSTSEQ: statusRow.TASK_LSTSEQ || processIdentity.taskLstseq,
        TEMPLATE_IDSEQ: templateIdentity.taskIdseq,
        TEMPLATE_LSTSEQ: templateIdentity.taskLstseq,
        ORDNO: statusRow.ORDNO || template.ORDNO || orderRoot.ORDNO || orderRoot.IDNO || '',
        CLNTNM: statusRow.CLNTNM || template.CLNTNM || orderRoot.CLNTNM || '',
        MATNO: statusRow.MATNO || template.MATNO || orderRoot.MATNO || orderRoot.PRDNO || '',
        MATNM: statusRow.MATNM || template.MATNM || orderRoot.MATNM || '',
        MATDESC: statusRow.MATDESC || template.MATDESC || orderRoot.MATDESC || '',
        CORPID: statusRow.CORPID || template.CORPID || orderRoot.CORPID || identity.corpid || '',
        NODE_FINDTTM: '',
        ORDER_PROCESS_FINDTTM: statusRow.FINDTTM || '',
        FINDTTM: statusRow.FINDTTM || '',
        EMPNM: owner,
        EMPNM2: owner,
        STFG: stfg,
        DISPLAY_STFG: statusInfo,
        SOURCE_STFG: '',
        PCT: pct,
        RMK: statusRow.RMK || '',
        ADDUSER: statusRow.ADDUSER || template.ADDUSER,
        ADDDTTM: statusRow.ADDDTTM || template.ADDDTTM,
        UPDUSER: statusRow.UPDUSER || template.UPDUSER,
        UPDDTTM: statusRow.UPDDTTM || template.UPDDTTM
      })
    },
    /**
     * 将所有订单任务骨架和维护记录按任务身份合并。
     */
    mergeOrderProcessRows: function (templateRows, statusRows) {
      var statusMap = {}
      this.normalizeRows(statusRows).forEach(function (item) {
        var key = this.getOrderProcessKey(item.TASK_IDSEQ, item.TASK_LSTSEQ)
        if (this.isNewerOrderProcessRow(item, statusMap[key])) statusMap[key] = item
      }.bind(this))
      return this.normalizeRows(templateRows).map(function (item) {
        var taskIdentity = this.getOrderProcessTaskIdentity(item)
        var key = this.getOrderProcessKey(taskIdentity.taskIdseq, taskIdentity.taskLstseq)
        return this.mergeOrderProcessStatus(item, statusMap[key])
      }.bind(this))
    },
    /**
     * 构造订单根节点展示数据。
     */
    buildOrderRootData: function () {
      var row = this.effectiveOrderRow || {}
      var ordno = row.REFIDNO || row.refidno || row.ORDNO || row.ordno || row.IDNO || row.idno || ''
      var orderTitle = this.buildOrderTitle(row)
      var owner = this.pickOrderOwner(row)
      var deliveryDate = row.SHPDTTM || row.FINDTTM || ''
      var rootStatus = this.getOrderRootStatus(row, ordno)
      return Object.assign({}, row, {
        CODE: 'ORDER_ROOT',
        PARENTNO: '#',
        RN: 0,
        WKNM: orderTitle,
        NODETY: 'ORDER',
        NODETITLE: orderTitle,
        DISPDTTM: deliveryDate ? '交货日期：' + deliveryDate : '',
        TASKNM: orderTitle || row.TASKNM || '',
        PROJECTNM: orderTitle || row.PROJECTNM || '',
        EMPNM: owner,
        EMPNM2: owner,
        FINDTTM: deliveryDate,
        STFG: rootStatus,
        DISPLAY_STFG: rootStatus,
        PCT: 0
      })
    },
    /**
     * 计算订单根节点状态，没有终态且存在订单号时视为进行中。
     */
    getOrderRootStatus: function (row, ordno) {
      var status = this.normalizeOrderStatus(row && row.STFG, Number(row && row.PCT) || 0)
      if (status === '已完成' || status === '已终止' || status === '已逾期') return status
      return ordno ? '进行中' : status
    },
    /**
     * 从订单行中选择根节点负责人。
     */
    pickOrderOwner: function (row) {
      row = row || {}
      return row.STAFFNM || row.EMPNM2 || row.EMPNM || row.ADDUSER || ''
    },
    /**
     * 将后端历史状态码和中文状态统一收敛为五态中文值。
     */
    normalizeOrderStatus: function (stfg, pct) {
      var rawStatus = String(stfg || '').trim()
      var status = rawStatus.toUpperCase()
      if (rawStatus === '已终止' || rawStatus === '已驳回' || rawStatus === '已撤销' || status === 'REJECTED' || status === 'CANCELLED') return '已终止'
      if (rawStatus === '已逾期' || rawStatus === '风险预警' || status === 'RISK') return '已逾期'
      if (pct >= 100 || rawStatus === '已完成' || status === 'DONE') return '已完成'
      if (rawStatus === '进行中' || status === 'RUNNING' || status === 'Y') return '进行中'
      if (rawStatus === '未开始' || rawStatus === '未启动' || rawStatus === '加载中' || status === 'INIT' || status === 'N' || status === 'LOADING') return '未开始'
      if (pct > 0) return '进行中'
      return '未开始'
    }
  }
}
